<template>
  <a
    @click.prevent="scrollToNextSection"
    class="scroll-down"
    :class="isContactPanelActive ? 'fadeout-desktop':'fadein-desktop'"
  >
    <img
      v-if="isBackgroundPrimary && isMobile"
      src="../assets/img/arrow-down-white.svg"
      alt="Przejdź dalej"
    />
    <img v-else src="../assets/img/arrow-down.svg" alt="Przejdź dalej" />
  </a>
</template>

<script>
import { bus } from "../main";

export default {
  name: "ScrollDown",
  props: {
    activeSection: Number,
    isContactPanelActive: Boolean,
    isMobile: Boolean,
    isBackgroundPrimary: Boolean
  },
  methods: {
    scrollToNextSection: function() {
      // const sections = document.getElementsByTagName("section");
      bus.$emit("activeSection");

      // return if activeSection is last section
      // if (this.activeSection + 1 >= sections.length) return;
      bus.$emit("scrollToNextSection", 1);
    }
  }
};
</script>

<style lang="scss">
.scroll-down {
  transform-origin: center;
  cursor: pointer;

  &:hover {
    transform: rotate(30deg);
  }

  &:focus {
    outline: none;
  }
}
</style>